const canvasClass = ".logo-preview_canvas";
const thumbnailsClass = ".logo-preview_thumbnail";
const logoPreviewClass = ".img-preview_canvas";

function firstLoadImage(dataMediaId, cb) {
  const currentCanvas = window.document.querySelector(
    `.product-gallery__carousel-item[data-media-id="${dataMediaId}"] ${canvasClass}`
  );
  const img_url_key = LOGO_POSITION.img;
  const img_url = window[dataMediaId][img_url_key];
  if (!currentCanvas.getAttribute("data-original-canvas"))
    currentCanvas.setAttribute("data-original-canvas", img_url);

  const context = currentCanvas.getContext("2d");
  const img = new Image();
  img.onload = () => {
    const loadedImageWidth = img.width;
    const loadedImageHeight = img.height;

    const scale_factor = Math.min(
      currentCanvas.width / loadedImageWidth,
      currentCanvas.height / loadedImageHeight
    );

    const newWidth = loadedImageWidth * scale_factor;
    const newHeight = loadedImageHeight * scale_factor;

    const x = currentCanvas.width / 3 - newWidth / 3;
    const y = currentCanvas.height / 3 - newHeight / 3;

    context.drawImage(img, x, y, newWidth, newHeight);
    if (typeof cb === "function") cb();
  };
  img.src = img_url;

  const thumbnails = window.document.querySelectorAll(
    `.product-gallery__thumbnail[data-media-id="${dataMediaId}"] ${thumbnailsClass}`
  );

  for (let i = 0; i < thumbnails.length; i++) {
    const currentThumbnail = thumbnails[i];
    currentThumbnail.src = img_url;
  }
}

const LOGO_DEFAULTS = {
  xPos: 330,
  yPos: 150,
  width: 50,
  height: 50,
  img: "preview-1",
};

var LOGO_POSITION = {};

function changeLogoPosition(target) {
  const newPositions = ITEM_LOGO_POSITION[target.value];
  if (newPositions) {
    LOGO_POSITION = newPositions;
    const fileInput = document.querySelector(".logo-preview_input-element");
    if (fileInput && fileInput.files[0]) {
      setLogoPreview(fileInput.files[0]);
    }
  }
}

function onChangeFileInput(target) {
  const file = target.files[0];
  const activeColor = document.querySelector(".color-swatch__item.active");

  try {
    const errorMessage = target
      .closest(".logo-preview_input")
      .querySelector(".error-message");
    if (errorMessage) errorMessage.parentElement.removeChild(errorMessage);

    if (checkFileFormat(file)) {
      const inputWrapperElement = document.querySelector(".logo-preview_input");
      if (inputWrapperElement) {
        inputWrapperElement.classList.add("invalid");
        const errorMessage = document.createElement("span");
        errorMessage.classList.add("error-message");
        errorMessage.innerText = "Invalid file";
        inputWrapperElement.appendChild(errorMessage);
        return false;
      }
    }
  } catch (error) {
    console.error({error});
  }
  setLogoPreview(file);
  setTimeout(() => {
    if (activeColor) activeColor.click();
  }, 300);
}

function checkFileFormat(file) {
    const validFormats = new Array("ai", "png", "eps");
    const fileNameParts = file?.name.split(".");
    const fileExtension = fileNameParts? fileNameParts[fileNameParts.length - 1].toLowerCase() : [];

    if (validFormats.indexOf(fileExtension) < 0) {
      return true;
    }
    
    return false;
}

const setLogoPreview = async (file) => {
  let fileConverted;
  const fileNameParts = file?.name.split(".");
  const type = fileNameParts? fileNameParts[fileNameParts.length - 1] : [];

  try {
    if (type.toLowerCase() === "ai" || type.toLowerCase() === "eps") {
      const formData = new FormData();
      const inputButton = document.querySelector(".logo-preview_input-element");

      formData.append("inputFile", file);

     /**removing until logo upload credits from heroku for bg removal is updated */
      /** const swallResult = await Swal.fire({
        text: 'We can remove the background color from your uploaded image prior to customizing your item, would you like to do this?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Yes please',
        denyButtonText: `No, thank you`,
      })
        **/

      if (inputButton) {
        inputButton.classList.add("button-loading2");
        const overlay =
          inputButton.parentElement.querySelector(".loading-overlay");
        if (overlay) overlay.classList.add("show");
      }

      const rawResponse = await fetch(
        `https://api.cloudmersive.com/convert/image/${type.toUpperCase()}/to/PNG`,
        {
          method: "POST",
          headers: {
            Apikey: "7758cf0a-5215-4e04-938c-f920dab55895",
          },
          body: formData,
        }
      );
      const cloneResponse = rawResponse.clone();
      const [blob, json] = await Promise.allSettled([
        rawResponse.blob(),
        cloneResponse.json(),
      ]);
      // This means the api is not throwing error in the status code but returning a json response with all the details instead of the actual file
      if (rawResponse.status !== 200 || json.status === "fulfilled")
        throw "Invalid file";
      const newFileConverted = new File([blob.value], `${fileNameParts[0]}.svg`, {
        type: blob.value.type,
      });

      fileConverted = new File([blob.value], `${fileNameParts[0]}.png`, {
        type: blob.value.type,
      });

      /**removing until logo upload credits from heroku for bg removal is updated */
      /** if (swallResult.isConfirmed) {
        const formDataTransparent2 = new FormData();
        formDataTransparent2.append("image_file", newFileConverted);
        const rawTransparentResponse2 = await fetch(
          'https://clipdrop-api.co/remove-background/v1',
          {
            method: "POST",
            headers: {
              'x-api-key': "4de1fba5e168e38337fb9ec4c20da7527b269b9beb8249802fe25249684123b22b4f5879527b6613b0fc4019208b0e97",
            },
            body: formDataTransparent2,
          }
        );
        const cloneResponseTransparent2 = rawTransparentResponse2.clone();
        const [blobTransparent2, jsonTransparent2] = await Promise.allSettled([
          rawTransparentResponse2.blob(),
          cloneResponseTransparent2.json(),
        ]);

        if (rawTransparentResponse2.status !== 200 || jsonTransparent2.status === "fulfilled")
          throw "Invalid file";
        fileConverted = new File([blobTransparent2.value], `${fileNameParts[0]}.png`, {
          type: blobTransparent2.value.type,
        });
      }
        **/

      if (inputButton) {
        inputButton.classList.remove("button-loading2");
        const overlay =
          inputButton.parentElement.querySelector(".loading-overlay");
        if (overlay) overlay.classList.remove("show");
      }
    }

    // if (((type.toLowerCase() == "ai") || (type.toLowerCase() == "eps")) && !fileConverted) throw "Invalid file";

    if (type.toLowerCase() === "png") {
      const formDataTransparent = new FormData();
      const inputButton2 = document.querySelector(".logo-preview_input-element");

      formDataTransparent.append("image_file", file);
      if (inputButton2) {
        inputButton2.classList.add("button-loading2");
        const overlay2 =
          inputButton2.parentElement.querySelector(".loading-overlay");
        if (overlay2) overlay2.classList.add("show");
      }

       /**removing until logo upload credits from heroku for bg removal is updated */
      /** const swallResult2 = await Swal.fire({
        text: 'We can remove the background color from your uploaded image prior to customizing your item, would you like to do this?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Yes please',
        denyButtonText: `No, thank you`,
      });

      if (swallResult2.isConfirmed) {
        const rawTransparentResponse = await fetch(
          'https://clipdrop-api.co/remove-background/v1',
          {
            method: "POST",
            headers: {
              'x-api-key': "4de1fba5e168e38337fb9ec4c20da7527b269b9beb8249802fe25249684123b22b4f5879527b6613b0fc4019208b0e97",
            },
            body: formDataTransparent,
          }
        );

        const cloneResponseTransparent = rawTransparentResponse.clone();
        const [blobTransparent, jsonTransparent] = await Promise.allSettled([
          rawTransparentResponse.blob(),
          cloneResponseTransparent.json(),
        ]);
        
        // This means the api is not throwing error in the status code but returning a json response with all the details instead of the actual file
        if (rawTransparentResponse.status !== 200 || jsonTransparent.status === "fulfilled")
          throw "Invalid file";
        fileConverted = new File([blobTransparent.value], `${fileNameParts[0]}.png`, {
          type: blobTransparent.value.type,
        });
      }
        **/

      if (inputButton2) {
        inputButton2.classList.remove("button-loading2");
        const overlay2 =
          inputButton2.parentElement.querySelector(".loading-overlay");
        if (overlay2) overlay2.classList.remove("show");
      }
    }

    ((file) => {
      const logoImage = URL.createObjectURL(file);
      const canvas = window.document.querySelectorAll(canvasClass);
      for (let i = 0; i < canvas.length; i++) {
        const currentCanvas = canvas[i];
        const context = currentCanvas.getContext("2d");
        // const originalImage = currentCanvas.getAttribute("data-original-canvas");
        // LOGO_POSITION.img = originalImage;
        const dataMediaId = currentCanvas.getAttribute("data-media-id");
        // context.reset();
        context.resetTransform();

        firstLoadImage(dataMediaId, () => {
          const img = new Image();
          img.onload = () => {
            const sectorWidth = LOGO_POSITION?.width || LOGO_DEFAULTS.width;
            const sectorHeight = LOGO_POSITION?.height || LOGO_DEFAULTS.height;

            const loadedImageWidth = img.width;
            const loadedImageHeight = img.height;

            const scale_factor = Math.min(
              sectorWidth / loadedImageWidth,
              sectorHeight / loadedImageHeight
            );

            const newWidth = loadedImageWidth * scale_factor;
            const newHeight = loadedImageHeight * scale_factor;

            const x = sectorWidth / 3 - newWidth / 3;
            const y = sectorHeight / 3 - newHeight / 3;

            if (LOGO_POSITION?.rotation)
              context.rotate((LOGO_POSITION.rotation * Math.PI) / 180);
            context.drawImage(
              img,
              (LOGO_POSITION?.xPos || LOGO_DEFAULTS.xPos) + x,
              (LOGO_POSITION?.yPos || LOGO_DEFAULTS.yPos) + y,
              newWidth,
              newHeight
            );
            const dataMediaId = currentCanvas.getAttribute("data-media-id");
            const dataMediaVariant =
              currentCanvas.getAttribute("data-media-option");
            const newPreview = currentCanvas.toDataURL("png");

            const thumbnail = window.document.querySelector(
              `[data-media-id="${dataMediaId}"] ${thumbnailsClass}`
            );
            thumbnail.src = newPreview;

            const logoPreview = window.document.querySelector(
              `${logoPreviewClass}[data-media-id="${dataMediaId}"]`
            );
            logoPreview.src = newPreview;
            logoPreview.setAttribute("data-zoom", newPreview);
            // console.log({fileConverted});
            createImagesProperties(
              {
                logo: fileConverted? fileConverted : file,
                preview: dataURLtoFile(newPreview, "preview.png"),
              },
              dataMediaVariant
            );
          };
          img.src = logoImage;
        });
      }
    })(fileConverted || file);
  } catch (error) {
    console.error({error});
    const inputWrapperElement = document.querySelector(".logo-preview_input");
    if (inputWrapperElement) {
      inputWrapperElement.classList.add("invalid");
      const errorMessage = document.createElement("span");
      errorMessage.classList.add("error-message");
      errorMessage.innerText = "Invalid file";
      inputWrapperElement.appendChild(errorMessage);
    }
    const inputElement = document.querySelector(".logo-preview_input-element");
    if (inputElement) {
      inputElement.value = "";
    }
  }
};

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[arr.length - 1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

const SESSION_STORAGE_NAME = "session-info-ford";

const getSessionInformation = () => {
  try {
    const payload = window.sessionStorage.getItem(SESSION_STORAGE_NAME);
    const parsedPayload = JSON.parse(payload);
    return parsedPayload;
  } catch (error) {
    return null;
  }
};

const setSessionInformation = (newPayload) => {
  try {
    const payload = JSON.stringify(newPayload);
    window.sessionStorage.setItem(SESSION_STORAGE_NAME, payload);
    return true;
  } catch (error) {
    return false;
  }
};

function create_UUID() {
  var dt = new Date().getTime();
  const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

const updateSessionInformation = (field, payload) => {
  let actualInformation = getSessionInformation();
  if (!actualInformation)
    actualInformation = {
      id: create_UUID(),
    };
  actualInformation[field] = payload;
  return setSessionInformation(actualInformation);
};

const uploadFiles = async (logo, preview, variant) => {
  const bucket = "projectnamedropforddealer";
  const region = "us-east-1";
  const sessionInfo = getSessionInformation() || { id: create_UUID() };
  const user_id = sessionInfo.id;
  const cloudfrontUrl = "https://d3n3xeh8bv5jru.cloudfront.net";

  AWS.config.update({
    region,
    credentials: {
      accessKeyId: "AKIA42BL74ACSWZD6BVZ",
      secretAccessKey: "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",
    },
  });
  const s3 = new AWS.S3({
    apiVersion: "2006-03-01",
    params: { Bucket: bucket },
  });
  const uploadFile = async (file) =>
    new Promise((resolve, reject) => {
      const url = `${user_id}/${variant}/${new Date().getTime()}-${file.name}`;
      s3.upload(
        {
          Key: url,
          Body: file,
        },
        (err) => {
          if (!err) {
            const imageUrl = `${cloudfrontUrl}/${url}`;
            resolve(imageUrl);
          } else reject(err);
        }
      );
    });
    
  const [previewUrl, logoUrl] = await Promise.allSettled([
    uploadFile(preview),
    uploadFile(logo),
  ]);
  
  if (previewUrl.status === "fulfilled" && logoUrl.status === "fulfilled") {
    updateSessionInformation(variant, {
      logo: logoUrl.value,
      preview: previewUrl.value,
    });

    const previewsInputs = document.querySelectorAll(
      `.product-preview_image[data-variant-option="${variant}"]`
    );
    for (let i = 0; i < previewsInputs.length; i++)
      previewsInputs[i].value = previewUrl.value;
    const logoInputs = document.querySelectorAll(
      `.product-vector_image[data-variant-option="${variant}"]`
    );
    for (let i = 0; i < logoInputs.length; i++)
      logoInputs[i].value = logoUrl.value;

    const logoFileInput = document.querySelector(".logo-preview_input-element");

    if (logoFileInput) logoFileInput.value = "";
  }
  // debugger;
  return {
    previewUrl,
    logoUrl,
  };
};

const createImagesProperties = async (images, variant) => {
  const { logo, preview } = images;
  const [logoResult, previewResult] = await Promise.allSettled([
    new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(logo);
      fileReader.onload = (e) => resolve(e.target.result);
    }),
    new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(preview);
      fileReader.onload = (e) => resolve(e.target.result);
    }),
  ]);

  updateSessionInformation(variant, {
    logoDataUrl: logoResult.value,
    logoName: logo.name,
    previewDataUrl: previewResult.value,
    variantName: variant,
  });

  const logoElement = document.createElement("input");
  logoElement.setAttribute("type", "hidden");
  logoElement.name = "properties[_VectorImage]";
  logoElement.id = "_VectorImage";
  logoElement.value = logoResult.value;

  const previewElement = document.createElement("input");
  previewElement.setAttribute("type", "hidden");
  previewElement.name = "properties[_PreviewImage]";
  previewElement.id = "_PreviewImage";
  previewElement.value = previewResult.value;

  const previewActualElement = document.querySelector("#_PreviewImage");
  if (previewActualElement)
    previewActualElement.parentElement.removeChild(previewActualElement);
  const logoActualElement = document.querySelector("#_VectorImage");
  if (logoActualElement)
    logoActualElement.parentElement.removeChild(logoActualElement);

  const form = document.getElementById("product_form");
  form.appendChild(previewElement);
  form.appendChild(logoElement);
};

const addNote = async (newNote = "") => {
  const cart = await fetch("/cart.json");
  const cartParsed = await cart.json();
  const actualCartNote = (cartParsed || {}).note || "";
  const note = (actualCartNote ? actualCartNote + ". " : "") + newNote;
  const result = await fetch("/cart/update.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      note,
    }),
  });

  return result.json();
};

function auxUpdatePreviewImage(target) {
  const dataMediaId = target.getAttribute("data-media-id");
  const imgElement = document.querySelector(
    `.img-preview_canvas[data-media-id="${dataMediaId}"]`
  );
  const actualPreview = imgElement.getAttribute("data-zoom");
  imgElement.setAttribute("data-src", actualPreview);
  imgElement.src = actualPreview;
}
